import type { DependencyContainer } from 'tsyringe';
import { ISurfaceAssistEngineToken } from './SurfaceAssistEngine';
import { BffSurfaceAssistEngine } from './BffSurfaceAssistEngine';
import { AssistSurfaceController } from './AssistSurfaceController';
import { SurfaceAssistViewModel } from './SurfaceAssistViewModel';
import { PinnedTilesStore } from '../PinnedTilesStore';

/**
 * Binds the surface assist engine to the BFF-backed implementation, and
 * registers the surface controller + assist view model as singletons so one
 * assist session (active filters + last result) persists across the surface
 * drill-in navigation. The pinned-tiles store is a singleton too, so the AMA
 * pin action, the Add-insight modal, and every surface gallery share one set of
 * custom tiles. Swap the bound engine to retarget the assist.
 */
export function registerSurfaceAssist(container: DependencyContainer): void {
    container.register(ISurfaceAssistEngineToken, { useClass: BffSurfaceAssistEngine });
    container.registerSingleton(AssistSurfaceController);
    container.registerSingleton(SurfaceAssistViewModel);
    container.registerSingleton(PinnedTilesStore);
}
